<template>
  <section class="intro mb-10" v-html="page.tekst"/>
</template>

<script>
import {mapState} from 'vuex';

export default {
  computed: {
    ...mapState(['page']),
  },
};
</script>

<style lang="sass" scoped>
.intro
  ::v-deep .row
    margin: 0 !important
    align-items: center

    .col-12
      padding: 0 12px
      @media screen and (min-width: map-get($grid-breakpoints, 'sm'))
        padding: 0

      &:nth-of-type(3)
        position: relative

        &::before
          @media screen and (min-width: map-get($grid-breakpoints, 'sm'))
            content: ''
            position: absolute
            top: -12%
            bottom: -4%
            left: -16%
            width: 4px
            background-image: url('~assets/img/line.png')

  @media screen and (min-width: map-get($grid-breakpoints, 'sm'))
    margin-bottom: 100px !important
</style>
